import { combineReducers } from 'redux';
import { list } from './list/list.reducer';
import { edit } from './edit/edit.reducer';
import { create } from './create/create.reducer';

export const ProcessTransition = combineReducers({
  list, edit, create
});